<template>
  <Hybrid />
</template>

<script>
import Hybrid from '../components/templates/Hybrid.vue'

export default {
  components: {
    Hybrid
  }
}
</script>
